export default __webpack_public_path__ + "static/media/mail.3a1244cb.svg";